import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=06c7ba91&scoped=true"
var script = {}
import style0 from "./Privacy.vue?vue&type=style&index=0&id=06c7ba91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c7ba91",
  null
  
)

export default component.exports